import { rooms } from "../data/rooms";
import { motion } from "framer-motion";

export default function RoomsSection() {
  return (
    <section
      id="rooms"
      className="py-32 bg-royal-light dark:bg-royal-dark scroll-mt-24"
    >

      <div className="max-w-7xl mx-auto px-6">

        {/* Section Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="relative inline-block">
            <span className="absolute inset-0 blur-3xl bg-gold/10 rounded-full"></span>
            <h2 className="relative text-4xl font-serif text-gold">
              Our Rooms
            </h2>
          </div>

          <p className="mt-4 text-charcoal/70 dark:text-ivory/70 max-w-2xl mx-auto">
            Each room at M R Suites Dharwad is crafted to offer a refined stay
            rooted in comfort and timeless elegance.
          </p>
        </motion.div>

        {/* Room Cards */}
        <div className="grid md:grid-cols-3 gap-10">
          {rooms.map((room, index) => (
            <motion.div
              key={room.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group bg-white/80 dark:bg-black/40 backdrop-blur-md rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition"
            >
              <div className="overflow-hidden">
                <img
                  src={room.image}
                  alt={room.name}
                  className="h-64 w-full object-cover group-hover:scale-105 transition duration-700"
                />
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-serif text-gold">
                  {room.name}
                </h3>
                <p className="mt-3 text-sm text-charcoal/70 dark:text-ivory/70">
                  {room.description}
                </p>
                <div className="mt-4 space-y-1">
                  {room.variants.map((variant, i) => (
                    <div
                      key={i}
                      className="flex justify-between text-sm text-charcoal/80 dark:text-ivory/80"
                    >
                      <span>{variant.type}</span>
                      <span className="text-gold font-medium">
                        ₹ {variant.price}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}